// ----------------------------------------------------------------------

const en = {
  en: `English`,
  title: `Title`,
  hi: `Hi`,
  email: `Email`,
  password: `Password`,
  sign_in: `Sign in`,
  username_is_required: `User Name is required`,
  password_is_required: `Password is required`,
  show: `Show`,
  managment: `Managment`,
  username: `User Name`,
  //nav specific
  educational_institutions: `Educational institutions`,
  about_educational_institution: `About institution classes`,
  educational_institution_classes: `Educational institution classes`,
  educational_institution_divisions: `Educational institution divisions`,
  educational_institution_students: `Educational institution students`,
  educational_institution_teachers: `Educational institution teachers`,
  educational_institution_profile: `Educational institution profile `,
  educational_institution_families: `Educational institution families `,
  programs: `Program`,
  //nav
  educational_institution: `Educational Institution`,
  dashboard: `Dashboard`,
  classes: `Classes`,
  divisions: `Divisions`,
  students: `Students`,
  teachers: `Teachers`,
  subjects: `Subjects`,
  ads: `Ads`,
  notes: `Notes`,
  my_profile: `My Profile`,
  contact_us: `Contact Us`,
  export: `Export`,
  print: `Print`,
  confirm: `Confirm`,
  //forms
  female: `Female`,
  male: `Male`,
  add_new_school: `Add Educational Institution`,
  name_english: `Name English`,
  name_arabic: `Name Arabic`,
  address: `Address`,
  city: `City`,
  year_of_foundation: `Year Of Foundation`,
  facebook_url: `Facebook URL`,
  logo: `Logo`,
  introduction: `Introduction`,
  telephone2: `Second Telephone `,
  mobile_phone2: `Second Mobile Phone`,
  select_type: `Select Type`,
  //tables
  name: `Name`,
  type: `Type`,
  user_name: `User Name`,
  manager_name: `Manager Name`,
  telephone: `Telephone`,
  mobile_phone: `Mobile Phone`,

  action: `Action`,

  //subject
  add_new_subject: `Add New Subject`,
  add_subject: `Add  Subject`,
  subject_id: `Subject ID`,
  subject_name: `Subject Name`,
  add_subject_to_school: `Add subject to school`,
  total_grade: ` Total Grade`,
  add: `Add`,
  //class
  class_id: ` Class ID`,
  class_name: ` Class Name `,
  division: `Division`,
  //families
  add_new_family: `Add New Family`,
  family_id: `Family ID`,
  first_name: `First Name`,
  last_name: `Last Name`,

  //students
  add_new_student: `Add New Student`,
  //no data
  no_data: `No Data`,

  // add new student
  add_student_to_school: `Add Student To School`,
  add_family: `Add Family`,
  add_parent_to_school: `Add Parent To School`,
  phone_number: `Phone Number`,
  first_name_is_required: `First name is required`,
  last_name_is_required: `Last name is required`,
  phone_is_required: `Phone is required`,
  address_is_required: `Address is required`,
  send: `Send`,
  father_name: `Father Name`,
  father_name_is_required: `Father name is required`,
  mother_name: `Mother Name`,
  mother_name_is_required: `Mother name is required`,
  year_of_birth_is_required: `year of birth is required`,
  date_of_birth: `Date of birth`,
  father_phone_number: `Father Phone Number`,
  student_phone_number: `Student Phone Number`,
  gender_is_required: `Gender is required`,
  father_job: `Father Job`,
  mother_job: `Mother Job`,
  father_job_is_required: `Father job is required`,
  mother_job_is_required: `Mother job is required`,
  first_payment: `First Payment`,
  first_payment_is_required: `First payment is required`,
  parents: `Parents`,
  parent_id_is_required: `Parent id is required`,
  class_id_is_required: `class is required`,
  section_id_is_required: `Section id is required`,
  image: `Image`,
  gender: `Gender`,
  section: `Section`,
  points: `Points`,
  registration_status: `Registration Status`,
  unregistered: `Unregistered`,
  registered: `Registered `,
  // add teacher
  add_teacher_to_school: `Add Teacher To School`,
  experiences: `Experiences`,
  specialization: `Specialization`,
  title_is_required: `Title is required`,
  add_ads: `Add Adverts`,
  Title: `Title`,
  phone_number_is_not_valid: `Phone number is not valid`,
  too_short: `Too short`,
  too_long: `Too long`,
  id: `Id`,
  created_at: `Created At`,
  all_ads: `All Ads`,
  add_new_ads: `Add New Ads`,
  all_ads_for_school: `All Ads For School`,
  add_new_teacher: `Add New Teacher`,
  teachers_of_school: `Teachers Of School`,
  average_evaluation: `Average Evaluation`,
  year_of_birth: `Year Of Birth`,
  are_you_sure_you_want_to_delete_this_teacher:
    " Are You Sure You Want To Delete This Teacher ?",
  //grades && notes
  add_grade_for_student: `Add Grade For Student`,
  material_is_required: `Material is required`,
  materials: `Materials`,
  oral: `Oral`,
  written: `Written`,
  written_is_required: `Written is required`,
  wazaef: `Wazaef`,
  test: `Test`,
  test_is_required: `Test is required`,
  exam_is_required: `Exam is required`,
  exam: `Exam`,
  add_grade: `Add Grade`,
  show_grads: `Show Grade`,
  max_grade: "Max Grade",
  total: "Total",
  add_notes: `Add Note`,
  grades_of_student: `Grades Of Student`,
  notes_of_student: `Notes Of Student`,
  add_note_for_student: `Add Note For Student`,
  add_new_class: `Add New Class`,
  educational_institution_ads: `Educational Institution Ads`,
  add_image: `Add Image`,
  show_secretaries: `Show Secretaries`,
  educational_institutions_secretaries: `Educational Institutions Secretaries`,
  add_new_secretary: `Add New Secretary`,
  manager_dashboard: `Dashboard Managment`,
  student_name: "Student Name",
  note_id: "Note id",
  Total: "Total",
  sending_notes_page: "Sending Notes Page",
  from: "من",
  // division-info
  section_info: "Section Info",
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday ",
  Saturday: "Saturday",
  Friday: "Friday",
  week_days: "Week Days",
  daily_classes_schedule_for: "Daily Class Schedule For",
  class_number: "Class Number",
  subject: "Subjects ",
  start_time: "Start Time ",
  end_time: " End Time",
  class_1: " Class (1)",
  class_2: " Class (2)",
  class_3: "Class (3) ",
  class_4: " Class (4)",
  class_5: " Class (5)",
  class_6: "Class (6)",
  class_7: "Class (7) ",
  class_8: "Class (8) ",
  class_9: " Class (9)",
  students_for_section: " Student For Section ",
  student_id: " Student Id",
  section_name: "Section Name",
  receiving_notes: `Receiving Notes`,
  add_time_slot: "Add Time Slot",
  add_time_slot_for: "Add Time Slot For",
  select_day: " Select Day",
  select_subject: " Select Subject ",
  tests_grades_for_sections: "Test Grades for Student's  Section",

  // Add New Student
  add_student: "Add Student",
  add_student_to_school_for_family: "Add Student To School For Family",
  // new eductional institution info page
  role: "Role",
  manager_account_info: "Manager Account Information",
  new_educational_institution_info: "New Educational Institution Information",
  manager_account: "Manager Account",
  // add image to school page
  add_image_to_school_page: "Add Image To Educational Institution  Page",
  add_image_to: "Add Image To",
  school_image: " School Image",
  // School Teachers Page
  total_teachers: "Total Teachers",
  // School Ads Page
  total_ads: "Total Ads ",
  //
  //
  // complete translation for all
  login_page: `Login Page`,
  add_section: `Add Section`,
  add_classes_to_school: `Add Classes To School`,
  deserved_amount: `Deserved Amount`,
  add_new_classes: `Add New Classes`,
  class_is_required: `cLass Is Required`,
  deserved_amount_is_required: `Deserved Amount Is Required`,
  add_subject_to_class_is_required: `Add Subject To Class Is Required`,
  total_grade_is_required: `Total Grade Is Required`,
  add_subject_to_class: `Add Subject To Class `,
  add_subject_to: `Add Subject To`,
  add_section_to_class: `Add Section To Class`,
  number_is_required: `Number Is Required`,
  classification_is_required: `Classification Is Required`,
  select_classification: `Select Classification`,
  enter_section_number: `Enter Section Number`,
  days: `Days`,
  name_en_is_required: `name_I Is Required`,
  add_time_slot_page: `Add Time Slot Page`,
  material_id_is_required: `Material Id Is Required`,
  format_must_be_hh_mm_ss: `Format must be : hh mm ss`,
  start_time_is_required: `Start Time Is Required`,
  end_time_is_required: `End Time Is Required`,
  edit_student: `Edit Student`,
  sender: `Sender`,
  text: `Text`,
  user_id: `User Id `,
  Arabic: `Arabic `,
  date: `Date`,
  specialization_is_required: `Specialization Is Required`,
  reciving_notes: `Receiving Notes`,
  sending_notes: `Sending Notes`,
  add_educational_institution_page: `Add Educational Institution Page`,
  name_ar_is_required: `Name In Arabic Is Required`,
  type_is_required: `Type Is Required`,
  email_is_required: `Email Is Required`,
  city_is_required: `City Is Required`,
  telephone_is_required: `Telephone Is Required`,
  mobile_phone_is_required: `Mobile Phone Is Required`,
  year_of_foundation_is_required: `Year Of Foundation Is Required`,
  manager_name_is_required: `Manager Name Is Required`,
  write_here: `Write Here`,
  logo_is_required: `Logo Is Required`,
  image_is_required: `Image Is Required`,
  save: `Save`,
  all_subjects_page: `All Subject Page`,
  all_educational_institution_page: `All Educational Institution Page`,
  rows_per_page: `Rows Per Page`,
  edit: `Edit`,
  delete: `Delete`,
  are_you_sure_you_want_to_delete_this_item: `Are you sure you want to delete this item`,
  cancel: `Cancel`,
  delete_item: `Delete Item`,
  are_you_sure_you_want_to_delete_this_familly: `Are you sure you want to delete this familly`,
  name_is_required: `name is required`,
  log_out: `Log Out`,
  tests_max_total: `Tests max total`,
  // family Student page
  family_students: "Family Student",
  // All student management
  all_students: "كل الطلاب",
  //edit section page
  edit_section: "Edit Section",
  save_edit: "Save Section",
  // payment For Student page
  payment_info: "Payment Information",
  add_payment: "Add Payment",
  payment_info_page: "Payment Information Page",
  payment_number: " Payment Number",
  amount: "Amount",
  date_of_pay: "Date of Pay",
  remain_amount: "Remain Amount",
  // Add payment For Student page
  add_payment_for_student_page: "Add Payment For Student Page",
  amount_is_required: "Amount is requierd",
  add_payment_for_student: "add Payment For Student",
  ministerial_decisions: `Ministerial Decisions`,
  samples: `Samples`,
  scientific: `Scientific`,
  literary: `Literary`,
  add_new_sample: `Add New Sample`,
  material_id: `Material id`,
  material_name: `Material Name`,
  question: `write a question  ..`,
  question_text: `Question Text`,
  answer1: `First Answer`,
  answer2: `Second Answer`,
  answer3: `Third Answer`,
  answer4: `Fourth Answer`,
  question_id: `Question id`,
  sample_id: `Sample id`,
  add_new_question: `Add new question`,
  questions: `Questions`,
  add_new_ministerial_decisions: `Add ministerial decisions`,
  time_of_sessions_required: `Time of sessions required`,
  number_of_sessions_required: `Number of sessions required`,
  number_of_sessions: `Number of sessions`,
  price_of_sessions: `Price of sessions`,
  time_of_sessions: `Time of sessions`,
  sessions: `Sessions`,
  add_new_session: `Add new session`,
  weekly_teacher_sessions: `Weekly teacher sessions`,
  total_sessions: `Total sessions`,
  teacher_name: `Teacher name`,
  locked: "Locked",
  unlocked: "UnLocked",
  school_id: "School id",
  school_name: "School Name",
  choose_season: `Choose season`,
  first_season: `First season`,
  second_season: `Second season`,
  questions_count: `Questions count`,
  show_results: `Show results`,
  result_of_student: `Result of student`,
  max_total: `Max total`,
  send_notification: `Send Notification`,
  msg:`Msg`,
  notifications:`Notifications`,
  message_is_required:`Message is required`,
  day_id:`Day`,
  
};

export default en;
